export enum Languages {
  en = 'en',
  ru = 'ru',
}
